<template>
<Dialog :header="$store.state.languages.lang_phrases.tedarikci_bilgileri" 
v-model:visible="$store.state.auth.supplierhaveopencustomattributes" 
:breakpoints="{'960px': '75vw', '640px': '98vw'}" 
:style="{width: '98vw',marginTop:'6vh'}" 
:modal="false"
:closeOnEscape="false"
:closable="false"
>
<div style="height: 80vh;">
<h4 class="text-primary">{{$store.state.languages.lang_phrases.tedarikcisi_oldugunuz_markalar_sizden}}</h4>
<!-- single brand -->
<TabView ref="tabview1">
    <TabPanel v-for="supplieropencuatomattribute in $store.state.auth.supplieropencuatomattributes" :header="supplieropencuatomattribute.supplier.name+' - '+supplieropencuatomattribute.brand.name">
      <SupplierCustomAttributesModalBrand :branditem="supplieropencuatomattribute" :id="supplieropencuatomattribute.brand.id" :countries="countries"></SupplierCustomAttributesModalBrand>
    </TabPanel>
</TabView>


</div>


<template #footer>    
    <!--<Button label="Yes" icon="pi pi-check" @click="closeModal" autofocus />-->
</template>
</Dialog>


</template>

<script>
import SupplierCustomAttributesModalBrand  from "./SupplierCustomAttributesModalBrand"
export default {

  name: 'SupplierCustomAttributesModal',

  data () {
    return {
    	show:false,
    	countries:[],
    }
  },
  components:{SupplierCustomAttributesModalBrand},
  mounted()
  {

  },
  computed:{
  	showmodal()
  	{
  		
  		this.getCountries()
  		return this.$store.state.auth.supplierhaveopencustomattributes
  	}
  },
  watch:{
  	showmodal(newval)
  	{
  		console.log("watch showmodal")
  		if(newval)
  		{
  			this.getCountries()
  		}
  	}
  },
  methods:{
  	async getCountries()
  	{
  		this.countries = await this.generalApiGetWithoutLoader("countries")
  	},  
  },
}
</script>

<style lang="css" scoped>
</style>